import React, { useState, useContext } from 'react';
import { FaTimes, FaUserShield } from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../../context/AppContext';

const AddAdminModal = ({ onClose, onSuccess }) => {
    const { baseUrl, validateForm ,authToken} = useContext(AppContext);
    const [admusername, setName] = useState("");
    const [admemail, setEmail] = useState("");
    const [admpassword, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [fieldErrors, setFieldErrors] = useState({});
    
    const uploadrecord = (e) => {
        e.preventDefault();

        const { isValid, errors } = validateForm([
            { field: 'admusername', type: 'name',     value: admusername },
            { field: 'admemail',    type: 'email',    value: admemail },
            { field: 'admpassword', type: 'password', value: admpassword },
        ]);

        if (admpassword && confirmPassword && admpassword !== confirmPassword) {
            errors.confirmPassword = 'Passwords do not match';
        }

        setFieldErrors(errors);
        if (!isValid || errors.confirmPassword) return;
        
        setLoading(true);
        setMessage({ type: '', text: '' });
        
        const formDataToSend = new FormData();
        formDataToSend.append("admusername", admusername);
        formDataToSend.append("admemail", admemail);
        formDataToSend.append("admpassword", admpassword);
        
      const adminToken = localStorage.getItem("authToken");

axios.post(
    `${baseUrl}/admin/register`,
    formDataToSend,
    {
        headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
        }
    }
)
        .then((response) => {
            console.log(response.data);
            if (response.data.success) {
                setMessage({ 
                    type: 'success', 
                    text: 'Admin added successfully!' 
                });
                
                setName("");
                setEmail("");
                setPassword("");
                setConfirmPassword("");
                setFieldErrors({});
                
                if (onSuccess) onSuccess();
                
                setTimeout(() => {
                    onClose();
                    window.location.href = '/admin/dashboard';
                }, 2000);
            } else {
                setMessage({ 
                    type: 'error', 
                    text: response.data.message || 'Cannot add admin' 
                });
            }
            setLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setMessage({ 
                type: 'error', 
                text: error.response?.data?.message || 'Error adding admin. Please try again.' 
            });
            setLoading(false);
        });
    };
    
    return (
        <div className="adm-user-modal-overlay" onClick={onClose}>
            <div className="adm-user-modal-content adm-add-admin-modal" onClick={(e) => e.stopPropagation()}>
    
                <div className="adm-user-modal-header">
                    <h2><FaUserShield /> Add New Admin</h2>
                    <button className="adm-user-modal-close" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="adm-user-modal-body">
                    {message.text && (
                        <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'}`}>
                            {message.text}
                        </div>
                    )}
                    
                    <form onSubmit={uploadrecord} className="adm-add-admin-form">
                       
                        <div className="adm-form-group">
                            <label>Full Name *</label>
                            <input
                                type="text"
                                value={admusername}
                                onChange={(event) => { setName(event.target.value); setFieldErrors(p => ({...p, admusername: ''})); }}
                                placeholder="Enter admin name"
                                required
                            />
                            {fieldErrors.admusername && <small style={{color:'red'}}>{fieldErrors.admusername}</small>}
                        </div>

                        <div className="adm-form-group">
                            <label>Email Address *</label>
                            <input
                                type="email"
                                value={admemail}
                                onChange={(event) => { setEmail(event.target.value); setFieldErrors(p => ({...p, admemail: ''})); }}
                                placeholder="admin@example.com"
                                required
                            />
                            {fieldErrors.admemail && <small style={{color:'red'}}>{fieldErrors.admemail}</small>}
                        </div>

                        <div className="adm-form-group">
                            <label>Password *</label>
                            <input
                                type="password"
                                value={admpassword}
                                onChange={(event) => { setPassword(event.target.value); setFieldErrors(p => ({...p, admpassword: ''})); }}
                                placeholder="Minimum 6 characters"
                                required
                            />
                            {fieldErrors.admpassword && <small style={{color:'red'}}>{fieldErrors.admpassword}</small>}
                        </div>

                        <div className="adm-form-group">
                            <label>Confirm Password *</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(event) => { setConfirmPassword(event.target.value); setFieldErrors(p => ({...p, confirmPassword: ''})); }}
                                placeholder="Re-enter password"
                                required
                            />
                            {fieldErrors.confirmPassword && <small style={{color:'red'}}>{fieldErrors.confirmPassword}</small>}
                        </div>
                    </form>
                </div>

                <div className="adm-user-modal-footer">
                    <button type="button" className="adm-user-modal-btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button type="button" className="adm-user-modal-btn-primary" onClick={uploadrecord} disabled={loading}>
                        {loading ? 'Adding...' : 'Add Admin'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddAdminModal;